import { LayoutModule } from '@angular/cdk/layout';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { ServiceWorkerModule } from '@angular/service-worker';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import * as Sentry from '@sentry/angular-ivy';
import { DxSwitchModule, DxTagBoxModule, DxToastModule } from 'devextreme-angular';
import { DxAccordionModule } from 'devextreme-angular';
import { DxButtonModule } from 'devextreme-angular';
import { DxButtonGroupModule } from 'devextreme-angular';
import { DxChartModule } from 'devextreme-angular';
import { DxCheckBoxModule } from 'devextreme-angular';
import { DxDataGridModule } from 'devextreme-angular';
import { DxDateBoxModule } from 'devextreme-angular';
import { DxDropDownBoxModule } from 'devextreme-angular';
import { DxDropDownButtonModule } from 'devextreme-angular';
import { DxFormModule } from 'devextreme-angular';
import { DxHtmlEditorModule } from 'devextreme-angular';
import { DxListModule } from 'devextreme-angular';
import { DxLoadIndicatorModule } from 'devextreme-angular';
import { DxLoadPanelModule } from 'devextreme-angular';
import { DxLookupModule } from 'devextreme-angular';
import { DxNumberBoxModule } from 'devextreme-angular';
import { DxPopoverModule } from 'devextreme-angular';
import { DxPopupModule } from 'devextreme-angular';
import { DxRadioGroupModule } from 'devextreme-angular';
import { DxScrollViewModule } from 'devextreme-angular';
import { DxSelectBoxModule } from 'devextreme-angular';
import { DxSpeedDialActionModule } from 'devextreme-angular';
import { DxTabPanelModule } from 'devextreme-angular';
import { DxTextAreaModule } from 'devextreme-angular';
import { DxTextBoxModule } from 'devextreme-angular';
import { DxToolbarModule } from 'devextreme-angular';
import { DxTooltipModule } from 'devextreme-angular';
import { DxTreeListModule } from 'devextreme-angular';
import { DxValidatorModule } from 'devextreme-angular';
import config from 'devextreme/core/config';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  EmptyLayoutComponent,
  MainLayoutComponent,
  SideNavInnerToolbarModule,
  TopNavigationToolbarModule,
} from './layouts';
import { EmptyLayoutFooterComponent } from './layouts/empty-layout/emty-layout-footer/empty-layout-footer.component';
import { SingleCardModule } from './modules/shared/components/single-card/single-card.component';
import { SharedModule } from './modules/shared/shared.module';
import {
  ContactUsComponent,
  LoadingComponent,
  LoginComponent,
  PasswordRecoveryComponent,
  PatientSignUpComponent,
  PrivacyComponent,
  SupplyRequestComponent,
  TermsConditionsComponent,
  UserComponent,
  UserFormComponent,
} from './pages';
import {
  FooterModule,
  HeaderModule,
} from './shared/components/layout';
import { UppercaseDirective } from './shared/directive/uppercase.directive';
import {
  GlobalHttpInterceptorService,
  GlobalInterceptorService,
  HttpHeaderInterceptor,
} from './shared/interceptor';
import { CacheInterceptorService } from './shared/interceptor/cache-interceptor.service';
import { AppInfoService, AuthService, DateHelperService, ScreenService } from './shared/services/general';
import {
  RecentPatientService,
} from './shared/services/ocl';
import { reducers } from './stores/app.state';
import { FusionAuthEffects } from './stores/effects/fusion-auth.effects';
import {NgIdleKeepaliveModule} from "@ng-idle/keepalive";
//import {MomentModule} from "angular2-moment";
import { TrackCapsDirective } from './shared/directive/track-caps.directive';
import { Router } from '@angular/router';
import {MicToJsonService} from "./shared/components/ocl/mic-to-json-button/mic-to-json.service";
import {NgIdleModule} from "@ng-idle/core";


@NgModule({
  declarations: [
    AppComponent,
    UppercaseDirective,
    LoadingComponent,
    UserComponent,
    UserFormComponent,
    EmptyLayoutComponent,
    MainLayoutComponent,
    LoginComponent,
    PasswordRecoveryComponent,
    TermsConditionsComponent,
    PrivacyComponent,
    ContactUsComponent,
    PatientSignUpComponent,
    SupplyRequestComponent,
    EmptyLayoutFooterComponent,
    TrackCapsDirective
  ],
  imports: [
    BrowserModule,
    LayoutModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    SideNavInnerToolbarModule,
    TopNavigationToolbarModule,
    DxTextBoxModule,
    DxSelectBoxModule,
    DxValidatorModule,
    DxTreeListModule,
    DxPopupModule,
    DxDateBoxModule,
    DxHtmlEditorModule,
    DxButtonModule,
    DxTextAreaModule,
    DxAccordionModule,
    DxLookupModule,
    DxNumberBoxModule,
    DxChartModule,
    DxCheckBoxModule,
    DxTabPanelModule,
    DxFormModule,
    DxScrollViewModule,
    DxPopoverModule,
    DxListModule,
    DxTooltipModule,
    DxToolbarModule,
    DxLoadPanelModule,
    DxButtonGroupModule,
    DxLookupModule,
    DxSpeedDialActionModule,
    DxRadioGroupModule,
    DxDropDownButtonModule,
    DxDropDownBoxModule,
    DxLoadIndicatorModule,
    DxDataGridModule,
    DxTagBoxModule,
    DxSwitchModule,
    DxToastModule,
    FooterModule,
    HeaderModule,
    NgIdleKeepaliveModule.forRoot(),
    //NgIdleModule.forRoot(),
    //MomentModule,
    //@ts-ignore
    StoreModule.forRoot(reducers, {}),
    EffectsModule.forRoot([FusionAuthEffects]),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    SharedModule,
    SingleCardModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ],
  providers: [
    AuthService,
    ScreenService,
    AppInfoService,
    RecentPatientService,
    CookieService,
    {
      provide: ErrorHandler,
      useClass: GlobalInterceptorService,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GlobalHttpInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpHeaderInterceptor,
      multi: true,
    }, {
      provide: APP_INITIALIZER,
      // tslint:disable-next-line:no-empty
      useFactory: () => () => { },
      //deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
  ],
  exports: [
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(trace: Sentry.TraceService) {
    config({
      forceIsoDateParsing: true,
    });
  }
}
